var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"dot error"}),_vm._v(" "),_c('span',{staticClass:"subtitle-1"},[_vm._v("REC")])])}]

export { render, staticRenderFns }